import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.regexp.replace.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapGetters } from 'vuex';
import { buildProductAlternates } from '~/helpers/seo-helpers';
export default {
  name: 'ProductSeo',
  props: {
    product: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    isMarketplace: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    baseURL: 'request/baseURL'
  })), {}, {
    description() {
      if (!this.isMarketplace) {
        var currentDescription = this.product.description.main ? this.product.description.main.replace(/\n|\r|\t|<(?:.|\n)*?>/gm, '').slice(0, 150) : '';
        return this.product.additionalInformation.metaDescription || currentDescription;
      }

      return this.product.name ? "".concat(this.product.name, " en vente chez Maisons du Monde. D\xE9couvrez toutes les informations sur le produit et nos offres associ\xE9es.") : '';
    },

    canonical() {
      var canonical = {
        rel: 'canonical',
        href: this.url
      };
      return canonical;
    }

  }),

  head() {
    return {
      title: "".concat(this.product.name, " ").concat(this.product.line, " | Maisons du Monde"),
      meta: [{
        name: 'description',
        content: this.description
      }],
      link: [this.canonical, ...buildProductAlternates(this.product.marketplace, this.baseURL, this.product.additionalInformation.seo.alternates, this.product.reference)]
    };
  },

  render: h => h(null)
};